// CleanModeHint.jsx
import React from 'react';
import styled from 'styled-components';

import CleanModeHintImg from '../../img/img_clean_mode_hint.png';

import { color } from '../style/variables.js';
import { useTranslation } from 'react-i18next';
import { TranslationNamespace } from '../resource/translationNamespace.js';

export const CleanModeHint = () => {
  const { t } = useTranslation();

  return (
    <StyledCleanModeHint>
      <img src={CleanModeHintImg} alt="hint" />
      <CleanModeHintContent>
        {t('tips_livestream_update_focus_mode', {
          ns: TranslationNamespace.LIVESTREAM,
        })}
      </CleanModeHintContent>
    </StyledCleanModeHint>
  );
};

CleanModeHint.propTypes = {};

const StyledCleanModeHint = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -75%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  z-index: 2;
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 ${color.neutral['0_alpha_20']};
  background: ${color.neutral[10]};

  & > img {
    width: 48px;
    height: 48px;
  }
`;

const CleanModeHintContent = styled.div`
  text-align: center;
  font-size: 12px;
  line-height: 18px;
  color: ${color.white};
`;

export default CleanModeHint;
